/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The InlineResponse422 model module.
 * @module model/InlineResponse422
 * @version v0.3
 */
export default class InlineResponse422 {
  /**
   * Constructs a new <code>InlineResponse422</code>.
   * @alias module:model/InlineResponse422
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>InlineResponse422</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse422} obj Optional instance to populate.
   * @return {module:model/InlineResponse422} The populated <code>InlineResponse422</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse422();
      if (data.hasOwnProperty('terms_required'))
        obj.termsRequired = ApiClient.convertToType(data['terms_required'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} termsRequired
 */
InlineResponse422.prototype.termsRequired = undefined;
